import { useNavigate } from 'react-router-dom';
import Template from '../../../component/Template';
import useAuth from '../../../component/useAuth';
import { useEffect } from 'react';
import Api from '../../../component/Api';
import { useState } from 'react';
import React, { useRef } from "react";

import { Link } from 'react-router-dom';

import '../../../Assets/css/vendors/datatables.css';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'datatables.net-bs4/js/dataTables.bootstrap4.min.js';

import logo from "../../../Assets/images/gif/danger.gif";

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import { useDownloadExcel } from 'react-export-table-to-excel';

export default function Bvoc_Course() {
    const navigate = useNavigate();
    const isAuth = useAuth();
    if (isAuth === false) {
        navigate("/admin/")
    }

    const { http } = Api();

    const [courses, setCoursesData] = useState([]);
    const [isDelete, setDelete] = useState(false);
    const [deleteid, setDeleteid] = useState(false);
    const [istost, settost] = useState(false);
    const tableRef = useRef(null);
    const [retryAttempt, setRetryAttempt] = useState(0);

    // ---------- STATE DECLARATIONS ----------
    const [faculty, setFacultyData] = useState([]);
    const [facultyId, setFacultyId] = useState("");

    const [discipline, setDisciplineData] = useState([]);
    const [disciplineId, setDisciplineId] = useState("");

    const [semester, setSemester] = useState([]);
    const [semesterId, setSemesterId] = useState("");

    // Course component types (last dropdown)
    const [coursecomponentstypes, setCourseComponentTypeData] = useState([]);
    const [courseComponentTypeId, setCourseComponentTypeId] = useState("");
    const [bvoccoursesListingData, setBvoccoursesListingData] = useState([]);
    const [coursecompchange, setCourseCompchange] = useState(false);
    const [sortBy, setSortBy] = useState({ column: null, direction: 'asc' });
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredAndSortedData, setfilteredAndSortedData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [total_count, setTotal] = useState(null);
    const [reload, setReload] = useState(false);

    // Export states - ADDED FOR EXPORT FUNCTIONALITY
    const [exportData, setExportData] = useState([]);
    const exportTableRef = useRef(null);

    const [ismobile, setIsmobile] = useState(false);
    const togglemenu = () => {
        setIsmobile(!ismobile);
    };

    // ADDED FOR EXPORT FUNCTIONALITY
    const { onDownload: onExportExcel } = useDownloadExcel({
        currentTableRef: exportTableRef.current,
        filename: 'Bvoc_Course_Database',
        sheet: 'Courses',
    });

    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: 'Course Database',
        sheet: 'Course',
    });

    useEffect(() => {
        http.get('/Admin/getBvocCourseFaculty', {
            params: {
                scheme_id: 4
            }
        })
            .then((response) => {
                setFacultyData(response.data.data);
            })
            .catch((error) => {
                console.log("error==",error.response.data.status_code)
                console.log("error==",error.response.data.http_status)
                const statusCode = error.response?.data?.status_code;
                const httpStatus = error.response?.data?.http_status;
                const message = error.response?.data?.message;

                if (httpStatus === 401 && statusCode === "ERR9") {
                    toast.error("Invalid Token");
                    setTimeout(() => {
                        navigate("/admin/");
                    }, 5000);
                } else {
                    toast.error(message || "Something went wrong");
                }

                console.error("Error fetching Course data:", error);

            });
    }, [reload]);

    const handleFacultyChange = (e) => {
        const value = e.target.value;

        if (value) {
            setFacultyId(value);
            sessionStorage.setItem("faculty_id", value);
        } else {
            setFacultyId("");
            sessionStorage.removeItem("faculty_id");
        }

        // Reset dependent dropdowns
        setDisciplineData([]);
        setDisciplineId("");
        setSemesterId("");
        setCourseComponentTypeData([]);
        setCourseComponentTypeId("");
    };

    useEffect(() => {
        const getBvocCourseDiscipline = () => {
            http
                .get('/Admin/getBvocCourseDiscipline', {
                    params: {
                        scheme_id: 4,
                        faculty_id: facultyId
                    }
                })
                .then((response) => {
                    setDisciplineData(response.data.data);
                })
                .catch((error) => {
                    const statusCode = error.response?.data?.status_code;
                    const httpStatus = error.response?.data?.http_status;
                    const message = error.response?.data?.message;

                    if (httpStatus === 401 && statusCode === "ERR9") {
                        toast.error("Invalid Token");
                        setTimeout(() => {
                            navigate("/admin/");
                        }, 5000);
                    } else {
                        toast.error(message || "Something went wrong");
                    }

                    console.error("Error fetching Course data:", error);

                });
        };

        if (facultyId) {
            getBvocCourseDiscipline();
        } else {
            setDisciplineData([]);
        }
    }, [facultyId]);

    const handleDisciplineChange = (e) => {
        const value = e.target.value;

        if (value) {
            setDisciplineId(value);
            sessionStorage.setItem("discipline_id", value);
        } else {
            setDisciplineId("");
            sessionStorage.removeItem("discipline_id");
        }

        // Reset dependent dropdowns
        setSemesterId("");
        setCourseComponentTypeData([]);
        setCourseComponentTypeId("");
    };

    useEffect(() => {
        const getSemester = () => {
            http
                .get('/Admin/getSemester', {
                    params: {
                        scheme_id: 4
                    }
                })
                .then((response) => {
                    setSemester(response.data);
                })
                .catch((error) => {
                    const statusCode = error.response?.data?.status_code;
                    const httpStatus = error.response?.data?.http_status;
                    const message = error.response?.data?.message;

                    if (httpStatus === 401 && statusCode === "ERR9") {
                        toast.error("Invalid Token");
                        setTimeout(() => {
                            navigate("/admin/");
                        }, 5000);
                    } else {
                        toast.error(message || "Something went wrong");
                    }

                    console.error("Error fetching Course data:", error);

                });
        };

        getSemester();
    }, [reload]);

    const handleSemesterChange = (e) => {
        const value = parseInt(e.target.value, 10);

        if (value) {
            setSemesterId(value);
        } else {
            setSemesterId("");
        }

        // Reset dependent course dropdown
        setCourseComponentTypeData([]);
        setCourseComponentTypeId("");
    };

    useEffect(() => {
        const getBvocCourseComponentStructure = () => {
            http
                .get('/Admin/getBvocCourseComponentStructure', {
                    params: {
                        scheme_id: 4,
                        sem: semesterId,
                        discipline_id: disciplineId
                    }
                })
                .then((response) => {
                    if (Array.isArray(response.data)) {
                        setCourseComponentTypeData(response.data);
                    } else {
                        setCourseComponentTypeData([]);
                        toast.error(response.data?.message || "No Course component type data found");
                    }
                })
                .catch((error) => {
                    const statusCode = error.response?.data?.status_code;
                    const httpStatus = error.response?.data?.http_status;
                    const message = error.response?.data?.message;

                    if (httpStatus === 401 && statusCode === "ERR9") {
                        toast.error("Invalid Token");
                        setTimeout(() => {
                            navigate("/admin/");
                        }, 5000);
                    } else {
                        toast.error(message || "Something went wrong");
                    }

                    console.error("Error fetching Course data:", error);

                });
        };

        if (semesterId && disciplineId) {
            getBvocCourseComponentStructure();
        }
    }, [semesterId, disciplineId]);

    const handleCourseComponentChange = (e) => {
        const value = e.target.value;

        if (value) {
            setCourseComponentTypeId(value);
        } else {
            setCourseComponentTypeId("");
        }
    };

    useEffect(() => {
        const getBvoccoursesListing = () => {
            http.get('Admin/BvoccoursesListing', {
                params: {
                    faculty_id: facultyId || '',
                    discipline_id: disciplineId || '',
                    semester_id: semesterId || '',
                    course_curriculum_structure_component_id: courseComponentTypeId || ''
                }
            })
                .then((response) => {
                    setBvoccoursesListingData(response.data || []);
                 
                }).catch((error) => {
                    const statusCode = error.response?.data?.status_code;
                    const httpStatus = error.response?.data?.http_status;
                    const message = error.response?.data?.message;

                    if (httpStatus === 401 && statusCode === "ERR9") {
                        toast.error("Invalid Token");
                        setTimeout(() => {
                            navigate("/admin/");
                        }, 5000);
                    } else {
                        toast.error(message || "Something went wrong");
                    }

                    console.error("Error fetching Course data:", error);

                });
        };

        getBvoccoursesListing();
    }, [facultyId, disciplineId, semesterId, courseComponentTypeId, reload])

    /* CUSTOME DATA TABLE BEGINS HERE */

    const handleSearchInputChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleSort = (column) => {
        const newSortBy = {
            column,
            direction: sortBy.column === column && sortBy.direction === 'asc' ? 'desc' : 'asc',
        };
        setSortBy(newSortBy);
    };

    useEffect(() => {
        const filteredAndSortedData = [...bvoccoursesListingData].filter(courseDatas => {
            return (
                courseDatas.course_code?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                courseDatas.course_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                courseDatas.faculty_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                courseDatas.discipline_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                courseDatas.semester_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                courseDatas.status?.toLowerCase().includes(searchQuery.toLowerCase())
            );
        }).sort((a, b) => {
            if (sortBy.direction === 'asc') {
                return a[sortBy.column] > b[sortBy.column] ? 1 : -1;
            } else {
                return a[sortBy.column] < b[sortBy.column] ? 1 : -1;
            }
        });

        const itemsPerPage = 50;
        const startIndex = (currentPage - 1) * itemsPerPage;
        const paginatedData = filteredAndSortedData.slice(startIndex, startIndex + itemsPerPage);

        setfilteredAndSortedData(paginatedData);
        setTotalPages(Math.ceil(filteredAndSortedData.length / itemsPerPage));
        setTotal(filteredAndSortedData.length);

    }, [searchQuery, sortBy, bvoccoursesListingData, currentPage]);

    const renderSortIcon = (columnName) => {
        if (sortBy.column === columnName) {
            return sortBy.direction === 'asc' ? <i className="fa fa-sort-up ml-1" aria-hidden="true"></i> : <i className="fa fa-sort-down ml-1" aria-hidden="true"></i>;
        }
        return <i className="fa fa-sort ml-1" aria-hidden="true"></i>;
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const clearAllSearchData = () => {
        setFacultyData([]);
        setFacultyId("");
        setDisciplineData([]);
        setDisciplineId("");
        setSemester([]);
        setSemesterId("");
        setCourseComponentTypeData([]);
        setCourseComponentTypeId("");
        setReload(!reload);

    }

    // Sort userlog based on sortBy state
    const sortedCourse = [...courses].sort((a, b) => {
        if (sortBy.direction === 'asc') {
            return a[sortBy.column] > b[sortBy.column] ? 1 : -1;
        } else {
            return a[sortBy.column] < b[sortBy.column] ? 1 : -1;
        }
    });

    const [showFilter, setShowFilter] = useState(false);
    const toggleFilter = () => {
        setShowFilter(!showFilter);
    };

    const closeFilter = () => {
        setShowFilter(false);
    };

    // ADDED EXPORT FUNCTIONS
    const handleExportToExcel = () => {
        try {
            // Get all filtered and sorted data (not paginated)
            const allFilteredData = [...bvoccoursesListingData].filter(courseDatas => {
                if (!searchQuery) return true;
                return (
                    courseDatas.course_code?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    courseDatas.course_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    courseDatas.faculty_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    courseDatas.discipline_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    courseDatas.semester_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    courseDatas.status?.toLowerCase().includes(searchQuery.toLowerCase())
                );
            }).sort((a, b) => {
                if (!sortBy.column) return 0;
                if (sortBy.direction === 'asc') {
                    return a[sortBy.column] > b[sortBy.column] ? 1 : -1;
                } else {
                    return a[sortBy.column] < b[sortBy.column] ? 1 : -1;
                }
            });

            setExportData(allFilteredData);

            // Trigger download after state update
            setTimeout(() => {
                onExportExcel();
            }, 100);

        } catch (error) {
            console.error('Error preparing export data:', error);
            toast.error('Error exporting data');
        }
    };

    const handleCustomExportToCSV = () => {
        try {
            // Get all filtered and sorted data
            const allFilteredData = [...bvoccoursesListingData].filter(courseDatas => {
                if (!searchQuery) return true;
                return (
                    courseDatas.course_code?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    courseDatas.course_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    courseDatas.faculty_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    courseDatas.discipline_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    courseDatas.semester_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    courseDatas.status?.toLowerCase().includes(searchQuery.toLowerCase())
                );
            }).sort((a, b) => {
                if (!sortBy.column) return 0;
                if (sortBy.direction === 'asc') {
                    return a[sortBy.column] > b[sortBy.column] ? 1 : -1;
                } else {
                    return a[sortBy.column] < b[sortBy.column] ? 1 : -1;
                }
            });

            // Create CSV content
            const headers = ['Sl No', 'Course Code', 'Course Title', 'Faculty', 'Discipline', 'Semester', 'Status'];
            const csvContent = [
                headers.join(','),
                ...allFilteredData.map((item, index) => [
                    index + 1,
                    `"${item.course_code || ''}"`,
                    `"${item.course_name || ''}"`,
                    `"${item.faculty_name || ''}"`,
                    `"${item.discipline_name || ''}"`,
                    `"${item.semester_name || ''}"`,
                    `"${item.status || ''}"`
                ].join(','))
            ].join('\n');

            // Download CSV
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', 'Bvoc_Course_Database.csv');
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } catch (error) {
            console.error('Error exporting data:', error);
            toast.error('Error exporting data');
        }
    };

    useEffect(() => {
        if (istost) {
            toast.success(istost);
            sessionStorage.removeItem("message");
            settost(false);
        }
    }, [istost]);

    const handleDeleteSuccess = () => {
        http.get(`/Admin/BvocCoursedelete/${deleteid}`)
            .then((response) => {
                if (response.data.status_code === "MSG3") {
                    setDelete(false);
                    sessionStorage.setItem("message", "Course deleted successfully!");
                    toast.success("Course deleted successfully!");
                    setReload(!reload);
                }
            })
            .catch((error) => {
                const statusCode = error.response?.data?.status_code;
                const httpStatus = error.response?.data?.http_status;
                const message = error.response?.data?.message;

                if (httpStatus === 401 && statusCode === "ERR9") {
                    toast.error("Invalid Token");
                    setTimeout(() => {
                        navigate("/admin/");
                    }, 5000);
                } else {
                    toast.error(message || "Something went wrong");
                }

                console.error("Error fetching Course data:", error);

            });
    };

    const encodeID = id => {
        return btoa(id);
    };

    const encodeSemID = semid => {
        return btoa(semid);
    };

    const handleDelete = (id) => {
        setDeleteid(id);
        setDelete(true);
    }

    const handleCancel = () => {
        setDelete(false);
    }

    // MODIFIED EXPORT DROPDOWN HANDLER
    const handleExportDropdownToggle = (event) => {
        const selectedValue = event.target.value;
        if (selectedValue === "1") {
            // Handle PDF conversion
            toast.info('PDF export functionality to be implemented');
        } else if (selectedValue === "2") {
            handleCustomExportToCSV();
        } else if (selectedValue === "3") {
            handleExportToExcel();
        }
        // Reset dropdown
        event.target.value = "";
    };

    // for kebabmenu
    const [openKebabCourseId, setOpenKebabCourseId] = useState(null);

    const toggleKebabMenu = (courseId) => {
        setOpenKebabCourseId(prevCourseId => (prevCourseId === courseId ? null : courseId));
    };

    // Close kebab menu when clicking anywhere on the screen
    useEffect(() => {
        function handleClickOutside(event) {
            const isOpen = openKebabCourseId !== null;

            if (isOpen && !event.target.closest('.kebab-menu')) {
                setOpenKebabCourseId(null);
            }
        }

        document.body.addEventListener('click', handleClickOutside);
        return () => {
            document.body.removeEventListener('click', handleClickOutside);
        };
    }, [openKebabCourseId]);

    return (
        <>
            <ToastContainer />
            <div className={`modal fade show ${isDelete ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="modal-toggle-wrapper">
                                <ul className="modal-img">
                                    <li> <img src={logo} /></li>
                                </ul>
                                <h4 className="text-center pb-2">Are you sure you want to delete?</h4>
                                <p className="text-center">This action cannot be undone. Please confirm if you want to proceed with the deletion.</p>
                                <div className="d-flex justify-content-center mt-3">
                                    <button className="btn btn-danger mx-2" onClick={() => handleDeleteSuccess()}>Delete</button>
                                    <button className="btn " style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }} data-bs-dismiss="modal" onClick={() => handleCancel()}>Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Template>
                {/* Container-fluid starts*/}
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-header card-heading">
                                    <div className="py-3 d-flex justify-content-between align-items-center">
                                        <h5 className="lbl1">Bvoc Courses</h5>
                                        <div className="d-none d-lg-flex">
                                            <div className="light-box">
                                                    <a style={{ marginLeft: "10px" }} onClick={toggleFilter} className="btn btn-light">
                                                        <i className={`fa fa-filter ${showFilter ? 'icon-close' : 'filter-icon'} show`} aria-hidden="true"></i>
                                                    </a>
                                                    &nbsp;&nbsp;
                                                </div>
                                            {/* MODIFIED EXPORT DROPDOWN INSTEAD OF SINGLE PDF BUTTON */}
                                            <div className="form-group m-r-10">
                                                <select
                                                    className="form-select btn-border "
                                                    onChange={handleExportDropdownToggle}
                                                    defaultValue=""
                                                    title="Export Options"
                                                >
                                                    <option value="" disabled>Export</option>
                                                    <option value="1">PDF</option>
                                                    <option value="2">CSV</option>
                                                    <option value="3">Excel</option>
                                                </select>
                                            </div>

                                            <Link className="lbl2 btn btn-primary form-group" to="/admin/bvoc_courseadd"
                                                title="Add New Course">
                                                <span className="icon">&#43;</span>
                                                <div className="txtsh"> Add <i className="bi bi-plus-square"></i></div>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className={`collapse ${showFilter ? 'show' : ''}`} id="collapseProduct" style={{ margin: "20px 20px 20px 20px" }}>
                                    <div className="card card-body list-product-body">
                                        <div className="row row-cols-xl-5 row-cols-lg-4 row-cols-md-3 row-cols-sm-2 row-cols-2 g-3">
                                            <div className="col">
                                                <select className="form-select scrollable-bar-select" aria-label="Default select example" defaultValue={false}
                                                    onChange={handleFacultyChange}>
                                                    <option value={0}>--Faculty--</option>
                                                    {faculty.map(facultys => (
                                                        <option value={facultys.id} key={facultys.id}>{facultys.faculty_name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col">
                                                <select className="form-select scrollable-bar-select" aria-label="Default select example" defaultValue={false}
                                                    onChange={handleDisciplineChange}>
                                                    <option value={0}>--Discipline--</option>
                                                    {discipline.map(disciplines => (
                                                        <option value={disciplines.id} key={disciplines.id}>{disciplines.discipline_name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col">
                                                <select className="form-select scrollable-bar-select" aria-label="Default select example" defaultValue={false}
                                                    onChange={handleSemesterChange}>
                                                    <option value={0}>--Semester--</option>
                                                    {semester.map(sem => (
                                                        <option value={sem.semester_no} key={sem.semester_no}>{sem.semester_name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className="col">
                                                <select className="form-select scrollable-bar-select" aria-label="Default select example" defaultValue={false}
                                                    onChange={handleCourseComponentChange}>
                                                    <option value={0}>--Course component Type--</option>
                                                    {coursecomponentstypes.length > 0 && (
                                                        coursecomponentstypes.map(coursecomponentstype => (
                                                            <option key={coursecomponentstype.course_curriculum_structure_component_id} value={coursecomponentstype.course_curriculum_structure_component_id}>{coursecomponentstype.course_discipline_component}</option>
                                                        ))
                                                    )}
                                                </select>
                                            </div>
                                            <div className="col">
                                                <button className="btn btn-primary" onClick={clearAllSearchData} style={{ width: "100%" }}>Clear All</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card-body">
                                    <div className="card-body pdg1">
                                        <div className="table-responsive">
                                            <div className='row'>
                                                <div className='col-md-6 wdt' >
                                                    <p>
                                                        Showing {(currentPage - 1) * 50 + 1}{''}-
                                                        {Math.min((currentPage - 1) * 50 + 50, total_count)} of {total_count} entries
                                                    </p>
                                                </div>
                                                <div className='col-md-6 wdt' align='right'>
                                                    <input
                                                        type="text"
                                                        value={searchQuery}
                                                        onChange={handleSearchInputChange}
                                                        placeholder="Search..."
                                                        className='form-control'
                                                    />
                                                </div>
                                            </div>
                                            <table className="display dataTable table-striped table-bordered ex-v-table tab-font" ref={tableRef}>
                                                <thead>
                                                    <tr className="bg-primary">
                                                        <th >Sl No &nbsp;</th>
                                                        <th onClick={() => handleSort('course_code')} style={{ textAlign: "center", verticalAlign: "middle" }} >Course Code &nbsp;
                                                            {renderSortIcon('course_code')}</th>
                                                        <th width="30%" onClick={() => handleSort('course_name')} style={{ textAlign: "center", verticalAlign: "middle" }} >Course Title &nbsp;
                                                            {renderSortIcon('course_name')}</th>
                                                        <th width="20%" onClick={() => handleSort('faculty_name')} style={{ textAlign: "center", verticalAlign: "middle" }} >Faculty &nbsp;
                                                            {renderSortIcon('faculty_name')}</th>
                                                        <th width="20%" onClick={() => handleSort('discipline_name')} style={{ textAlign: "center", verticalAlign: "middle" }} >Discipline &nbsp;
                                                            {renderSortIcon('discipline_name')}</th>
                                                        <th onClick={() => handleSort('semester_name')} style={{ textAlign: "center", verticalAlign: "middle" }} >Semester &nbsp;
                                                            {renderSortIcon('semester_name')}</th>
                                                        <th onClick={() => handleSort('status')} style={{ textAlign: "center", verticalAlign: "middle" }} >Status &nbsp;
                                                            {renderSortIcon('status')}</th>
                                                        <th >Action &nbsp;</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {filteredAndSortedData && filteredAndSortedData.length > 0 ? (
                                                        filteredAndSortedData.map((item, index) => {
                                                            const serialNumber = (currentPage - 1) * 50 + index + 1;

                                                            return (
                                                                <tr key={item.id}>
                                                                    <td>{serialNumber}</td>
                                                                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>{item.course_code}</td>
                                                                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>{item.course_name}</td>
                                                                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>{item.faculty_name}</td>
                                                                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                                        {item.discipline_name}
                                                                    </td>
                                                                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                                        {item.semester_name}
                                                                    </td>
                                                                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>{item.status}</td>
                                                                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                                                                        <div className="kebab-menu">
                                                                            <button className="kebab-menu-button" onClick={() => toggleKebabMenu(item.id)}>
                                                                                &#8942;
                                                                            </button>
                                                                            <ul className="action">
                                                                                {openKebabCourseId === item.id && (
                                                                                    <div className="kebab-menu-items kebab-ht">
                                                                                        {item.verification_status != 'verified' && (
                                                                                            <li className="edit txt-aln-lft">
                                                                                                <Link to={`/admin/bvoc_courseedit/${encodeID(item.id)}/${encodeSemID(item.semester_id)}`} title="Edit">
                                                                                                    <i className="icon-pencil-alt"></i>&nbsp;Edit
                                                                                                </Link>
                                                                                            </li>
                                                                                        )}
                                                                                        {item.verification_status != 'verified' && (
                                                                                            <li className="delete txt-aln-lft">
                                                                                                <Link to="#" onClick={() => handleDelete(item.id)} title="Delete">
                                                                                                    <i className="icon-trash"></i>&nbsp;Delete
                                                                                                </Link>
                                                                                            </li>
                                                                                        )}
                                                                                        <li className="view txt-aln-lft">
                                                                                            <Link to={`/admin/bvoc_courseview/${encodeID(item.id)}`} title="View">
                                                                                                <span className="icon-eye" style={{ cursor: "pointer" }} />&nbsp;View
                                                                                            </Link>
                                                                                        </li>
                                                                                        {(item.course_curriculum_structure_component_id === 1 || item.course_curriculum_structure_component_id === 12) && (
                                                                                            <li className="viewpage txt-aln-lft">
                                                                                                <Link to="/admin/coursedisciplineAECmapping/" title="AEC Course Mapping">
                                                                                                    <i className="icon-pencil icon-lt-aln"></i>&nbsp;AEC Course &nbsp;Mapping
                                                                                                </Link>
                                                                                            </li>
                                                                                        )}
                                                                                    </div>
                                                                                )}
                                                                            </ul>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="8" className="text-center py-3">No Data Found</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                        {totalPages > 1 && (
                                            <nav aria-label="..." style={{ cursor: "pointer" }}>
                                                <ul className="pagination justify-content-center">
                                                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                        <span className="page-link pgn-clr" onClick={handlePreviousPage}><i className="bi bi-arrow-left-circle-fill"></i></span>
                                                    </li>
                                                    <li className={`page-item`}>
                                                        <span className="page-link pgn-clr" onClick={() => handlePageChange(1)}>1</span>
                                                    </li>
                                                    {currentPage > 4 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}
                                                    {[...Array(totalPages - 1).keys()].slice(currentPage > 4 ? currentPage - 3 : 1, currentPage + 2).map((pageNumber) => (
                                                        <li key={pageNumber} className={`page-item ${pageNumber + 1 === currentPage ? 'act-clr' : ''}`}>
                                                            <span className="page-link pgn-clr" onClick={() => handlePageChange(pageNumber + 1)}>{pageNumber + 1}</span>
                                                        </li>
                                                    ))}
                                                    {currentPage < totalPages - 3 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}

                                                    <li className={`page-item`}>
                                                        <span className="page-link pgn-clr" onClick={() => handlePageChange(totalPages)}>{totalPages}</span>
                                                    </li>

                                                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                        <span className="page-link pgn-clr" onClick={handleNextPage}><i className="bi bi-arrow-right-circle-fill"></i></span>
                                                    </li>
                                                </ul>
                                            </nav>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Hidden table for export - This table contains only the data without action buttons */}
                <div style={{ display: 'none' }}>
                    <table ref={exportTableRef}>
                        <thead>
                            <tr>
                                <th>Sl No</th>
                                <th>Course Code</th>
                                <th>Course Title</th>
                                <th>Faculty</th>
                                <th>Discipline</th>
                                <th>Semester</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {exportData.map((item, index) => (
                                <tr key={item.id || index}>
                                    <td>{index + 1}</td>
                                    <td>{item.course_code}</td>
                                    <td>{item.course_name}</td>
                                    <td>{item.faculty_name}</td>
                                    <td>{item.discipline_name}</td>
                                    <td>{item.semester_name}</td>
                                    <td>{item.status}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </Template>
        </>
    );
}